export const environment = {
  production: true,
  devMode: false,
  authMock: false,
  demoSkipLogin: false,
  mode: 'sandbox' as const,
  apiUrl: 'https://scapi.qztbox.com',
  otaUrl: 'https://scapi.qztbox.com',
  contentApiUrl: 'https://scapi.qztbox.com',
  visitorAppUrl: 'https://nsc.qztbox.com',
  mediaUrl: '${COS_MEDIA_URL}',
  cyberZenoKey: '${CYBERZENO_KEY}',
  cyberZenoEndpoint: 'https://cz.labzeno.com',
  turnstileSiteKey: '0x4AAAAAAFk2CC_sG1d6Onlm',
};
